import { SvgIconBase, } from "./Base";


export const Check = () => {
	return (
		<SvgIconBase width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" aria-label="Check" fill="none">
			<title>Check</title>
			<path
				d="M13.5 4.5L6 12L2.5 8.5"
				stroke="currentColor"
				strokeWidth="2.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</SvgIconBase>
	);
};

